import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import Swal from "sweetalert2";

export default function EditModal({
  id = "EditModal",
  lang,
  proxy,
  token,
  item,
  onDone,
  setData,
}) {
  const [loading, setLoading] = useState(true);

  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: { edits: [] },
  });

  const { fields, update, replace } = useFieldArray({
    control,
    name: "edits",
    keyName: "keyId",
  });

  useEffect(() => {
    const load = async () => {
      if (!item?.soanHang) {
        replace([]);
        setLoading(false);
        return;
      }
      setLoading(true);
      const {
        dataLogsPXk: datalogpxk,
        lenhxuathang,
        idLogsPXK,
        phieuxuatkhosaas,
        o_data,
      } = item.soanHang;
      const {
        dataLogsPXKXN = [],
        idLogsPXKXN,
        phieuxuatkhosaas: phieuxuatkhosaasShip,
      } = item?.shipHang || {};
      // const dataLogsPXk = datalogpxk || dataLogsPXKXN || [];
      // const mappedOdata =
      //   !dataLogsPXKXN || dataLogsPXKXN.length === 0
      //     ? o_data?.[0]?.details.map((item) => {
      //         const find = datalogpxk?.find(
      //           ({ delivery_detail_id }) =>
      //             delivery_detail_id == item?.old_delivery_detail_id
      //         );
      //         const { delivery_detail_id, ...props } = find || {};

      //         return find
      //           ? {
      //               ...item,
      //               ...props,
      //             }
      //           : item;
      //       })
      //     : dataLogsPXKXN;
      const mappedOdata =
        !dataLogsPXKXN || dataLogsPXKXN.length === 0
          ? o_data?.[0]?.details.map((item) => {
              const foundItems = datalogpxk?.filter(
                ({ delivery_detail_id }) =>
                  delivery_detail_id == item?.old_delivery_detail_id
              );

              if (!foundItems || foundItems.length === 0) return item;

              const mergedProps = foundItems.reduce((acc, curr) => {
                const { delivery_detail_id, ...rest } = curr;
                return { ...acc, ...rest };
              }, {});

              return { ...item, ...mergedProps };
            })
          : dataLogsPXKXN;

      const dataLogsPXk = mappedOdata;

      const fetchLotData = async (dataLog) => {
        const { masanpham, khocon, delivery_detail_id, tenkho } = dataLog;
        try {
          const resp = await fetch(
            `${proxy()}/api/SyncERP/Lot?id=${masanpham}&sub=${khocon}`,
            {
              headers: {
                Authorization: token,
                "Content-Type": "application/json",
              },
            }
          );
          const { data = [] } = await resp.json();

          const soLotsMap = new Map();
          const uniqueViTriSet = new Set();
          data.forEach(({ solot, soluongconton, donvitinh, mavitrikho }) => {
            if (solot) {
              if (soLotsMap.has(solot)) {
                soLotsMap.get(solot).soluongconton += soluongconton;
              } else {
                soLotsMap.set(solot, { solot, soluongconton, donvitinh });
              }
            }
            if (mavitrikho) uniqueViTriSet.add(mavitrikho);
          });

          const danhSachSoLot = Array.from(soLotsMap.values()).map((x) => ({
            label: x.solot,
            value: x.solot,
            ...x,
          }));
          const danhSachViTriKho = Array.from(uniqueViTriSet).map((v) => ({
            label: v,
            value: v,
          }));
          const tonLot =
            danhSachSoLot.find(({ value }) => value === dataLog?.solot)
              ?.soluongconton || 0;

          return {
            phieuxuatkhosaas:
              !dataLogsPXKXN || dataLogsPXKXN.length === 0
                ? phieuxuatkhosaas
                : phieuxuatkhosaasShip,
            idLogsPXK:
              !dataLogsPXKXN || dataLogsPXKXN.length === 0
                ? idLogsPXK
                : idLogsPXKXN,
            khocon: dataLog.khocon,
            delivery_detail_id,
            donvitinh: dataLog.donvitinh,
            masanpham,
            tenkho,
            labelLenhXuatHang: [
              lenhxuathang,
              masanpham,
              dataLog.delivery_detail_id,
            ]
              .filter(Boolean)
              .join("_"),
            solot: dataLog?.solot
              ? { label: dataLog.solot, value: dataLog.solot }
              : null,
            vitritrongkho: dataLog?.vitritrongkho
              ? { label: dataLog.vitritrongkho, value: dataLog.vitritrongkho }
              : null,
            danhSachSoLot,
            danhSachViTriKho,
            ton: `${tonLot} Tấn`,
            soluongcanxuat: dataLog?.soluongcanxuat ?? 0,
            soluongtanxuatthucte: dataLog?.soluongcanxuat ?? "",
            // old_soluongtanxuatthucte: dataLog?.soluongtanxuatthucte ?? "",
          };
        } catch (e) {
          console.error(e);
          return null;
        }
      };

      const results = await Promise.all((dataLogsPXk || []).map(fetchLotData));
      const valid = results.filter(Boolean);
      replace(valid);
      setLoading(false);
    };

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, proxy, token]);

  const onSubmit = async ({ edits }) => {
    if (!edits?.length) return;
    const mapped = edits.map((row) => ({
      khocon: row.khocon,
      delivery_detail_id: row.delivery_detail_id,
      donvitinh: row.donvitinh,
      solot: row?.solot?.value || null,
      masanpham: row.masanpham,
      vitritrongkho: row?.vitritrongkho?.value || null,
      soluongcanxuat: Number(row?.soluongtanxuatthucte) || 0,
      soluongtanxuatthucte: Number(row?.soluongtanxuatthucte) || 0,
    }));

    // tất cả dòng đều cùng idLogsPXK
    const idLogsPXK = edits?.[0]?.idLogsPXK;
    await fetch(`${proxy()}/api/PXK/EditShipConfirmPhieuXuatKho`, {
      method: "PUT",
      headers: { Authorization: token, "content-type": "application/json" },
      body: JSON.stringify({
        phieuxuatkhosaas: edits?.[0]?.phieuxuatkhosaas,
        id: idLogsPXK,
        data: mapped,
      }),
    })
      .then((r) => r.json())
      .then(({ success, message }) => {
        if (success) {
          onDone();
        }
        Swal?.fire({
          icon: success ? "success" : "error",
          title: success ? lang["success"] : lang["error"],
          text: message,
          showConfirmButton: !success,
        });
        // onDone?.();
      });
  };

  return (
    <div className="modal fade" id={id}>
      <div className="modal-dialog" style={{ maxWidth: "80%" }}>
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center">
            <h5
              className="w-100"
              style={{ color: "#44a1a1", fontSize: 18, padding: "6px 0" }}
            >
              Cập nhật số lượng ship hàng
            </h5>
          </div>

          <div className="modal-body">
            <div className="container-fluid">
              <div className="row form-row align-items-center">
                <div className="col-sm-12">
                  <div className="header row mb-3">
                    <div className="col-sm-2">LXH/LĐĐNB</div>
                    <div className="col-sm-2">Số LOT</div>
                    <div className="col-sm-2">Kho Con</div>
                    <div className="col-sm-2">Vị trí</div>
                    <div className="col-sm-2">Tồn</div>
                    <div className="col-sm-2">Số Lượng (Tấn)</div>
                  </div>

                  {loading ? (
                    <div className="w-100 align-center">
                      <img
                        width={40}
                        src="/images/icon/load.gif"
                        alt="Loading..."
                      />
                    </div>
                  ) : (
                    fields.map((f, index) => {
                      const kho = [f.khocon, f.tenkho]
                        .filter(Boolean)
                        .join("_");
                      return (
                        <div className="input row mb-4" key={f.keyId}>
                          <div className="col-sm-2">
                            <input
                              className="form-control"
                              type="text"
                              value={f?.labelLenhXuatHang || ""}
                              readOnly
                            />
                          </div>

                          <div className="col-sm-2">
                            <Controller
                              control={control}
                              name={`edits.${index}.solot`}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={f?.danhSachSoLot || []}
                                  value={field.value || null}
                                  onChange={(opt) => {
                                    const tonStr =
                                      opt?.soluongconton != null
                                        ? `${opt.soluongconton} Tấn`
                                        : "";
                                    field.onChange(opt);
                                    update(index, {
                                      ...f,
                                      solot: opt,
                                      ton: tonStr,
                                    });
                                  }}
                                  placeholder={lang["select value"]}
                                  noOptionsMessage={() => (
                                    <>{lang["not found data"]}</>
                                  )}
                                  isDisabled
                                />
                              )}
                            />
                          </div>

                          <div className="col-sm-2">
                            <input
                              className="form-control"
                              type="text"
                              value={kho || ""}
                              readOnly
                            />
                          </div>

                          <div className="col-sm-2">
                            <Controller
                              control={control}
                              name={`edits.${index}.vitritrongkho`}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={f?.danhSachViTriKho || []}
                                  value={field.value || null}
                                  onChange={(opt) => field.onChange(opt)}
                                  placeholder={lang["select value"]}
                                  noOptionsMessage={() => (
                                    <>{lang["not found data"]}</>
                                  )}
                                  isDisabled
                                />
                              )}
                            />
                          </div>

                          <div className="col-sm-2">
                            <input
                              className="form-control"
                              type="text"
                              value={f?.ton || ""}
                              readOnly
                            />
                          </div>

                          <div className="col-sm-2">
                            <Controller
                              control={control}
                              name={`edits.${index}.soluongtanxuatthucte`}
                              rules={{
                                min: { value: 0, message: "Không nhỏ hơn 0" },
                                validate: (v) => {
                                  const value = Number(v);
                                  if (v === "" || isNaN(value))
                                    return "Phải là số";
                                  if (value <= 0 || !value)
                                    return "Phải lớn hơn 0";
                                  const oldValue = f.soluongtanxuatthucte;
                                  // if (value > oldValue) {
                                  //   return `Không được lớn hơn giá trị cũ (${oldValue})`;
                                  // }

                                  return true;
                                },
                              }}
                              render={({ field, fieldState }) => (
                                <>
                                  <input
                                    className="form-control"
                                    type="number"
                                    step="any"
                                    min={0}
                                    {...field}
                                  />
                                  {fieldState.error && (
                                    <small className="text-danger">
                                      {fieldState.error.message}
                                    </small>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit(onSubmit)}
              disabled={loading || isSubmitting || !fields.length}
            >
              {lang["btn.update"]}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              {lang["btn.close"]}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
